import React, { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import "./IkonaDetalj.scss";
import { getProductBySlug, getProducts } from "../../shop/api/products";
import AdManagerSlot from "../../components/AdvModule/AdManagerSlot";
import { useGlobalLocation } from "../../shared/LocationContext";
import { useCart } from "../../shared/CartContext";

const formatPrice = (num) => Number(num).toLocaleString("sr-RS") + " RSD";

export default function IkonaDetalj() {
  const { slug } = useParams();
  const { location } = useGlobalLocation();
  const { addToCart } = useCart();
  const [kolicina, setKolicina] = useState(1);
  const [dodat, setDodat] = useState(false);
  const [ikona, setIkona] = useState(null);
  const [slicne, setSlicne] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getProductBySlug(slug)
      .then(async (prod) => {
        setIkona(prod);
        const sve = await getProducts(prod.categories?.slug);
        setSlicne(sve.filter((p) => p.slug !== slug).slice(0, 4));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [slug]);

  const handleKupi = () => {
    if (!ikona || ikona.kolicina_na_stanju === 0) return;
    addToCart({
      slug: ikona.slug,
      title: ikona.name,
      cena: formatPrice(ikona.price),
      pic: ikona.images?.[0],
      tehnika: ikona.attributes?.tehnika,
      dimenzije: ikona.attributes?.dimenzije,
      sifra: ikona.attributes?.sifra,
    }, kolicina);
    setDodat(true);
    setTimeout(() => setDodat(false), 2500);
  };

  if (loading) {
    return <div className="ikona-detalj__loading">Učitavanje...</div>;
  }

  if (!ikona) {
    return (
      <div className="ikona-detalj__not-found">
        <p>Ikona nije pronađena.</p>
        <NavLink to="/prodavnica" className="ikona-detalj__back-btn">← Nazad na prodavnicu</NavLink>
      </div>
    );
  }

  const dostupno = ikona.kolicina_na_stanju > 0;

  return (
    <div className="ikona-detalj">

      <div className="ikona-detalj__breadcrumb">
        <NavLink to="/">Početna</NavLink>
        <span>›</span>
        <NavLink to="/prodavnica">Prodavnica</NavLink>
        <span>›</span>
        <NavLink to="/prodavnica">{ikona.categories?.name}</NavLink>
        <span>›</span>
        <span>{ikona.name}</span>
      </div>

      <div className="ikona-detalj__main">

        <div className="ikona-detalj__gallery">
          <div className="ikona-detalj__img-wrap">
            <img src={ikona.images?.[0]} alt={ikona.name} />
          </div>
        </div>

        <div className="ikona-detalj__info">
          <p className="ikona-detalj__sifra">Šifra: {ikona.attributes?.sifra}</p>
          <h1 className="ikona-detalj__title">{ikona.name}</h1>
          <div className="ikona-detalj__price">{formatPrice(ikona.price)}</div>

          <div className={`ikona-detalj__stock ${dostupno ? "ikona-detalj__stock--da" : "ikona-detalj__stock--ne"}`}>
            {dostupno ? `✓ Na stanju (${ikona.kolicina_na_stanju} kom)` : "✕ Nije dostupno"}
          </div>

          <div className="ikona-detalj__specs">
            <div className="ikona-detalj__spec">
              <span className="ikona-detalj__spec-label">Tehnika</span>
              <span className="ikona-detalj__spec-val">{ikona.attributes?.tehnika}</span>
            </div>
            <div className="ikona-detalj__spec">
              <span className="ikona-detalj__spec-label">Dimenzije</span>
              <span className="ikona-detalj__spec-val">{ikona.attributes?.dimenzije}</span>
            </div>
            <div className="ikona-detalj__spec">
              <span className="ikona-detalj__spec-label">Kategorija</span>
              <span className="ikona-detalj__spec-val">{ikona.categories?.name}</span>
            </div>
          </div>

          <p className="ikona-detalj__opis">{ikona.description}</p>

          <div className="ikona-detalj__actions">
            {dostupno && (
              <div className="ikona-detalj__qty">
                <button onClick={() => setKolicina((k) => Math.max(1, k - 1))}>−</button>
                <span>{kolicina}</span>
                <button onClick={() => setKolicina((k) => Math.min(ikona.kolicina_na_stanju, k + 1))}>+</button>
              </div>
            )}
            <button
              className={`ikona-detalj__btn-buy ${dodat ? "ikona-detalj__btn-buy--done" : ""} ${!dostupno ? "ikona-detalj__btn-buy--disabled" : ""}`}
              onClick={handleKupi}
              disabled={!dostupno}
            >
              {dodat ? "✓ Dodato" : dostupno ? "Kupi" : "Nije dostupno"}
            </button>
          </div>

          <div className="ikona-detalj__secondary-actions">
            <button className="ikona-detalj__btn-wish">♡ Lista želja</button>
            <button className="ikona-detalj__btn-share">↗ Podeli</button>
          </div>

          <div className="ikona-detalj__banner">
            <AdManagerSlot adUnitPath={location.pathname} slotNumber={"div-gpt-ad-1724367417806-0"} />
          </div>
        </div>
      </div>

      {slicne.length > 0 && (
        <div className="ikona-detalj__related">
          <h2 className="ikona-detalj__related-title">Slične ikone</h2>
          <div className="ikona-detalj__related-grid">
            {slicne.map((s) => (
              <NavLink key={s.id} to={`/prodavnica/${s.slug}`} className="ikona-detalj__related-card">
                <div className="ikona-detalj__related-img">
                  <img src={s.images?.[0]} alt={s.name} loading="lazy" />
                </div>
                <div className="ikona-detalj__related-body">
                  <p className="ikona-detalj__related-name">{s.name}</p>
                  <p className="ikona-detalj__related-meta">{s.attributes?.dimenzije}</p>
                  <p className="ikona-detalj__related-price">{formatPrice(s.price)}</p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}
